import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Web\ProductPage\AiProductPageUploadController::__invoke
* @see Http/Controllers/Web/ProductPage/AiProductPageUploadController.php:19
* @route '/product-page/{product}/ai-upload'
*/
const AiProductPageUploadController = (args: { product: string | number | { sku: string | number } } | [product: string | number | { sku: string | number } ] | string | number | { sku: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AiProductPageUploadController.url(args, options),
    method: 'post',
})

AiProductPageUploadController.definition = {
    methods: ["post"],
    url: '/product-page/{product}/ai-upload',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Web\ProductPage\AiProductPageUploadController::__invoke
* @see Http/Controllers/Web/ProductPage/AiProductPageUploadController.php:19
* @route '/product-page/{product}/ai-upload'
*/
AiProductPageUploadController.url = (args: { product: string | number | { sku: string | number } } | [product: string | number | { sku: string | number } ] | string | number | { sku: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { product: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'sku' in args) {
        args = { product: args.sku }
    }

    if (Array.isArray(args)) {
        args = {
            product: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        product: typeof args.product === 'object'
        ? args.product.sku
        : args.product,
    }

    return AiProductPageUploadController.definition.url
            .replace('{product}', parsedArgs.product.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Web\ProductPage\AiProductPageUploadController::__invoke
* @see Http/Controllers/Web/ProductPage/AiProductPageUploadController.php:19
* @route '/product-page/{product}/ai-upload'
*/
AiProductPageUploadController.post = (args: { product: string | number | { sku: string | number } } | [product: string | number | { sku: string | number } ] | string | number | { sku: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AiProductPageUploadController.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Web\ProductPage\AiProductPageUploadController::__invoke
* @see Http/Controllers/Web/ProductPage/AiProductPageUploadController.php:19
* @route '/product-page/{product}/ai-upload'
*/
const AiProductPageUploadControllerForm = (args: { product: string | number | { sku: string | number } } | [product: string | number | { sku: string | number } ] | string | number | { sku: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: AiProductPageUploadController.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Web\ProductPage\AiProductPageUploadController::__invoke
* @see Http/Controllers/Web/ProductPage/AiProductPageUploadController.php:19
* @route '/product-page/{product}/ai-upload'
*/
AiProductPageUploadControllerForm.post = (args: { product: string | number | { sku: string | number } } | [product: string | number | { sku: string | number } ] | string | number | { sku: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: AiProductPageUploadController.url(args, options),
    method: 'post',
})

AiProductPageUploadController.form = AiProductPageUploadControllerForm

export default AiProductPageUploadController